import React from "react";

import { Divider } from "./Divider";

export const BaseDivider: React.FC = () => <Divider marginTop={0} marginBottom={0} marginLeft={0} marginRight={0} />;
